module.exports = require('./lib')



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-plugin-transform-jsx/index.js
 ** module id = 520
 ** module chunks = 0
 **/